const VERBAL_LOOKUP = {
  0: {
    range: '<143',
    percentile: '<19th',
  },
  1: {
    range: '<143',
    percentile: '<19th',
  },
  2: {
    range: '<143',
    percentile: '<19th',
  },
  3: {
    range: '<143',
    percentile: '<19th',
  },
  4: {
    range: '<143',
    percentile: '<19th',
  },
  5: {
    range: '137-143',
    percentile: '6th to 19th',
  },
  6: {
    range: '139-145',
    percentile: '9th to 25th',
  },
  7: {
    range: '141-147',
    percentile: '14th to 32nd',
  },
  8: {
    range: '143-149',
    percentile: '19th to 40th',
  },
  9: {
    range: '147-153',
    percentile: '32nd to 59th',
  },
  10: {
    range: '149-155',
    percentile: '40th to 67th  ',
  },
  11: {
    range: '150-156',
    percentile: '45th to 72nd',
  },
  12: {
    range: '152-158',
    percentile: '53rd to 79th',
  },
  13: {
    range: '153-159',
    percentile: '59th to 82nd',
  },
  14: {
    range: '155-161',
    percentile: '67th to 88th',
  },
  15: {
    range: '159-165',
    percentile: '82nd to 96th',
  },
  16: {
    range: '161-167',
    percentile: '88th to 98th',
  },
  17: {
    range: '163-169',
    percentile: '92nd to 99th',
  },
  18: {
    range: '165-170',
    percentile: '96th to 99th',
  },
  19: {
    range: '166-170',
    percentile: '97th to 99th',
  },
  20: {
    range: '167-170',
    percentile: '98th to 99th',
  },
};

const QUANT_LOOKUP = {
  0: {
    range: '<142',
    percentile: '<11th',
  },
  1: {
    range: '<142',
    percentile: '<11th',
  },
  2: {
    range: '<142',
    percentile: '<11th',
  },
  3: {
    range: '<142',
    percentile: '<11th',
  },
  4: {
    range: '<142',
    percentile: '<11th',
  },
  5: {
    range: '136-142',
    percentile: '2nd to 11th',
  },
  6: {
    range: '138-144',
    percentile: '4th to 15th',
  },
  7: {
    range: '139-145',
    percentile: '6th to 18th',
  },
  8: {
    range: '141-147',
    percentile: '9th to 25th',
  },
  9: {
    range: '144-150',
    percentile: '15th to 36th',
  },
  10: {
    range: '146-152',
    percentile: '22nd to 44th',
  },
  11: {
    range: '147-153',
    percentile: '25th to 48th',
  },
  12: {
    range: '148-154',
    percentile: '29th to 51st',
  },
  13: {
    range: '151-157',
    percentile: '40th to 62nd',
  },
  14: {
    range: '154-160',
    percentile: '51st to 72nd',
  },
  15: {
    range: '155-161',
    percentile: '55th to 75th',
  },
  16: {
    range: '157-163',
    percentile: '62nd to 80th',
  },
  17: {
    range: '159-165',
    percentile: '69th to 85th',
  },
  18: {
    range: '161-167',
    percentile: '75th to 89th',
  },
  19: {
    range: '164-169',
    percentile: '83rd to 94th',
  },
  20: {
    range: '165-170',
    percentile: '85th to 96th',
  },
};

const getScaledScores = ({ points, variant }) => {
  const lookupTable = variant === 'verbal' ? VERBAL_LOOKUP : QUANT_LOOKUP;
  const entry = lookupTable[points];
  return entry;
};

export default getScaledScores;
